import Head from "next/head";
// import { make as SetUpdatePage } from "../../src/info/SetUpdatePage.bs";
import { make as SetUpdatePage } from "../../src/set-update/Set9UpdatePage.bs";

export default function SetUpdate({ anomalies }) {
  return (
    <>
      <Head>
        <meta content={"Set 18 Update"} property="og:title" />
        <meta
          property="og:image"
          content={"https://ap.tft.tools/img/gg17/keyart.png"}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <title>Set 18 Enchanted Wilds Information</title>
      </Head>
      <SetUpdatePage anomalies={anomalies} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const anomaliesResp = await fetch(
    `https://ap.tft.tools/static/s18/wisps_${locale}.json`,
  );
  const anomalies = await anomaliesResp.json();

  return {
    props: { anomalies },
    revalidate: 3600,
  };
}
